import Error404 from '@/shared/publish/Homework/Error404';
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/publish/Homework/Error404')({
  component: RouteComponent,
})

function RouteComponent() {
  return <Error404 />
}
